import { useState } from 'react';
import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect';
/**
 * Хук, который выполняет media-запрос и реагирует на изменения ширины viewport
 *
 * @param query media-запрос, например "(max-width: 768px)"
 * @returns Рещультат media-запроса
 *
 * @example
 * const isSmall = useMediaQuery('(max-width: 768px)'); // true, если viewport не шире 768px
 */
export function useMediaQuery(query) {
    const [isMatch, setIsMatch] = useState(false);
    useIsomorphicLayoutEffect(() => {
        if (!window.matchMedia) {
            return;
        }
        const matchQueryList = window.matchMedia(query);
        // Устанавливаем текущее значение
        setIsMatch(matchQueryList.matches);
        const handleChange = (e) => {
            setIsMatch(e.matches);
        };
        matchQueryList.addEventListener('change', handleChange);
        // Очищаем listener при размонтировании или изменении query
        return () => {
            matchQueryList.removeEventListener('change', handleChange);
        };
    }, [query]);
    return isMatch;
}
